import React from "react";
import { node } from "prop-types";
import HeroTitle from "@insightfulscience/atomic-react/Hero/Title";
import HeroDescription from "@insightfulscience/atomic-react/Hero/Description";

const HeroTitleSectionOmiq = ({ title, description }) => {
	return (
		<>
			<HeroTitle>{title}</HeroTitle>
			<HeroDescription spacing={{ mb: 12 }}>{description}</HeroDescription>
		</>
	);
};

HeroTitleSectionOmiq.propTypes = {
	title: node,
	description: node,
};

export default HeroTitleSectionOmiq;
